<script setup lang="ts">
const { sidebarId } = useGlobals()
const { state: sidebarState } = useSidebar()
const { sidebarTestId } = useTestId()
const { state: myself } = useSelf()
const desktop = isDesktop()
</script>

<template>
  <div
    :id="sidebarId"
    class="sidebar"
    :class="{ desktop }"
    :data-testid="sidebarTestId"
    :style="{ width: px(sidebarState.width) }"
  >
    <sidebar-self />
    <interface-scrollbar vertical>
      <div class="sidebar-elements">
        <sidebar-roots v-if="myself.user" />
        <sidebar-favorites />
        <sidebar-shared-folders />
      </div>
    </interface-scrollbar>
    <sidebar-dragger />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.sidebar
  @apply h-full relative border-r border-r-[#{$page-b-divider}] flex flex-col
  &:not(.desktop)
    @apply bg-[#{$pill-bg-default}]
  &.desktop
    @apply bg-[#{$pill-bg-default}]

.sidebar-elements
  @apply flex flex-col gap-[#{$sidebar-gap-content}]
  @apply py-1 // This is to allow selection backgrounds to not be cut off
</style>
